var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "team-detail" },
    [
      _c("content-header", [
        _c(
          "div",
          {
            staticClass: "header-left-box",
            attrs: { slot: "header-left" },
            slot: "header-left",
          },
          [
            _c(
              "div",
              { staticClass: "return-prev", on: { click: _vm.retuenPrev } },
              [
                _c("span", { staticClass: "icon-box" }, [
                  _c("span", { staticClass: "el-icon-arrow-left" }),
                ]),
                _c("span", { staticClass: "return-text" }, [
                  _vm._v(_vm._s(_vm.$t("teamDetail.FH"))),
                ]),
              ]
            ),
            _c("content-header-title", [
              _c("span", [_vm._v(_vm._s(_vm.$t("teamDetail.TDXQ")))]),
            ]),
          ],
          1
        ),
        _c(
          "div",
          {
            staticClass: "header-left-box",
            attrs: { slot: "header-right" },
            slot: "header-right",
          },
          [
            _vm.isbtn.btnEntryPractise
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: { click: _vm.goRace },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("teamDetail.JRLX")))]
                )
              : _vm._e(),
            _vm.isbtn.btnResetPractise
              ? _c(
                  "el-button",
                  {
                    directives: [
                      {
                        name: "auth",
                        rawName: "v-auth",
                        value: [["teacher", "student"], "pro"],
                        expression: "[['teacher', 'student'], 'pro']",
                      },
                    ],
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.resetMatch("reset")
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("teamDetail.CZLX")) + " ")]
                )
              : _vm._e(),
            _vm.isbtn.btnOpenPractise
              ? _c(
                  "el-button",
                  {
                    attrs: { type: "primary", size: "small" },
                    on: {
                      click: function ($event) {
                        return _vm.resetMatch("start")
                      },
                    },
                  },
                  [_vm._v(" " + _vm._s(_vm.$t("teamDetail.KTLX")))]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _c(
        "div",
        { staticClass: "main" },
        [
          _c("content-left", {
            attrs: {
              teamData: _vm.isStudentLogin
                ? _vm.teamData.teamDto
                : _vm.teamData,
              btnStatus: _vm.isbtn,
            },
          }),
          _c("div", { staticClass: "content-right" }, [
            _c(
              "div",
              [
                _c("tableTitle", [
                  _c(
                    "div",
                    {
                      staticClass: "header-left",
                      attrs: { slot: "header-left" },
                      slot: "header-left",
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("teamDetail.CYXX")) + " ")]
                  ),
                  _c(
                    "div",
                    {
                      staticClass: "header-right",
                      attrs: { slot: "header-right" },
                      slot: "header-right",
                    },
                    [
                      !_vm.edit
                        ? _c(
                            "div",
                            [
                              _vm.isbtn.btnDeleteTeam
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "danger", size: "small" },
                                      on: { click: _vm.teamDelete },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("teamDetail.CCTD"))
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                              _vm.isbtn.btnEditTeam
                                ? _c(
                                    "el-button",
                                    {
                                      attrs: { type: "primary", size: "small" },
                                      on: {
                                        click: function ($event) {
                                          _vm.edit = true
                                        },
                                      },
                                    },
                                    [
                                      _vm._v(
                                        " " + _vm._s(_vm.$t("teamDetail.BJTD"))
                                      ),
                                    ]
                                  )
                                : _vm._e(),
                            ],
                            1
                          )
                        : _c(
                            "div",
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small" },
                                  on: {
                                    click: function ($event) {
                                      _vm.edit = false
                                      _vm.getData()
                                    },
                                  },
                                },
                                [_vm._v(_vm._s(_vm.$t("teamDetail.QX")) + " ")]
                              ),
                              _c(
                                "el-button",
                                {
                                  attrs: { type: "primary", size: "small" },
                                  on: { click: _vm.saveTeam },
                                },
                                [_vm._v(_vm._s(_vm.$t("teamDetail.BC")) + " ")]
                              ),
                            ],
                            1
                          ),
                    ]
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "table-box" },
                  [
                    _c("c-table", {
                      attrs: {
                        tableData: _vm.teamData.memberList,
                        ISChangeCheckout: false,
                        edit: _vm.edit,
                        tableHeader: _vm.userTableHeader,
                        TableHeight: `calc(99%)`,
                      },
                      on: { operation: _vm.operation },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c(
              "div",
              [
                _c("tableTitle", [
                  _c(
                    "div",
                    {
                      staticClass: "header-left",
                      attrs: { slot: "header-left" },
                      slot: "header-left",
                    },
                    [_vm._v(" " + _vm._s(_vm.$t("teamDetail.LXJL")) + " ")]
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "table-box" },
                  [
                    _c("c-table", {
                      attrs: {
                        tableData: _vm.teamData.subVersionLogList,
                        ISChangeCheckout: false,
                        tableHeader: _vm.lxTableHeaderFilter,
                        TableHeight: `calc(99%)`,
                      },
                      on: { operation: _vm.operation },
                    }),
                  ],
                  1
                ),
              ],
              1
            ),
          ]),
        ],
        1
      ),
      _c("dialog-add-student", {
        ref: "dialogAddStudent",
        on: { saveClick: _vm.saveClick },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }